var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle2, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClaimPayout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Claim Payout Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "#000000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.983 34.718C39.3477 33.8197 38.0105 33.0529 36.4987 33.0529C34.811 33.0529 33.7593 33.7978 33.7593 34.9371C33.7593 37.8298 41.6043 36.5153 41.6043 41.1834C41.6043 43.3744 40.0049 44.9518 37.4627 45.2585V47.1435H35.7757V45.3031C33.5183 45.1498 32.0277 44.1631 31.1514 42.9362L32.5755 41.599C33.5183 42.8259 34.8767 43.462 36.4768 43.462C38.4056 43.462 39.501 42.6294 39.501 41.3141C39.501 38.1146 31.6553 39.5176 31.6553 35.0028C31.6553 32.9652 33.2992 31.4746 35.7757 31.2336V29.3706H37.4627V31.2556C39.2381 31.4746 40.6403 32.3291 41.3852 33.3596L39.983 34.718Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3936 19.9988C48.3446 21.3458 55.2059 29.0677 55.2059 38.3934C55.2059 41.7826 54.3001 44.9602 52.7159 47.6965",
    stroke: "#000000",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1996 45.8356L52.7135 47.6972L50.9902 43.5427",
    stroke: "#000000",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2802 45.3394C15.9711 36.9149 19.2281 27.1102 27.305 22.448C30.2393 20.7535 33.4449 19.9496 36.6058 19.9526",
    stroke: "#000000",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.752 17L36.6065 19.9547L33.8708 23.5244",
    stroke: "#000000",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5549 50.0081C44.9137 57.0855 34.7947 59.1676 26.7177 54.5047C23.7834 52.8094 21.4845 50.4357 19.9062 47.697",
    stroke: "#000000",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2764 52.5103L19.9072 47.6948L24.3669 48.2788",
    stroke: "#000000",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 63.5,
    r: 11.5,
    fill: "#05C379"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3899 59.8538L61.2908 67.7074L57.6094 64.1376",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimPayout);
export default __webpack_public_path__ + "static/media/claim-payout.6a45b0391a4f9b7718320d5fc1e59e13.svg";
export { ForwardRef as ReactComponent };